import React from "react";
import "./Message.css";

const VARIANT_CLASS = {
  danger: "message--danger",
  success: "message--success",
  warning: "message--warning",
  info: "message--info",
};

export default function Message({ variant = "info", children }) {
  const cls = VARIANT_CLASS[variant] || VARIANT_CLASS.info;

  return (
    <div className={`message ${cls}`} role="alert">
      {children}
    </div>
  );
}
